import { render, staticRenderFns } from "./CheckDefectRemarkDetail.vue?vue&type=template&id=01d8e3f4&scoped=true&"
import script from "./CheckDefectRemarkDetail.vue?vue&type=script&lang=js&"
export * from "./CheckDefectRemarkDetail.vue?vue&type=script&lang=js&"
import style0 from "./CheckDefectRemarkDetail.vue?vue&type=style&index=0&id=01d8e3f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8e3f4",
  null
  
)

export default component.exports